import {fetchWithTimeout, checkPermission, TIMEOUT, PERMISSION_ADMIN, PERMISSION_OPERATOR, PERMISSION_MONITORING} from './api_common.js';
import {getCookie, showToast, getFetchError, getCatchError} from '../app_common.js';

export const getApiDataEndpoint = async(pagePer, pageCur, sortTitle, sortOrder) => {
    if( !checkPermission('getApiDataEndpoint', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/data-endpoint?per_page=${pagePer}&page=${pageCur}${sortTitle.length>0?'&sort_title='+sortTitle:''}${sortOrder.length>0?'&sort_order='+sortOrder:''}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiDataEndpoint = async(sendData) => {
    if( !checkPermission('postApiDataEndpoint', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/data-endpoint`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiDataEndpointId = async(id) => {
    if( !checkPermission('getApiDataEndpointId', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/data-endpoint/${id}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const putApiDataEndpointId = async(id, sendData) => {
    if( !checkPermission('putApiDataEndpointId', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/data-endpoint/${id}`, {
            timeout: TIMEOUT,
            method: 'PUT',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const delApiDataEndpointId = async(id) => {
    if( !checkPermission('delApiDataEndpointId', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/data-endpoint/${id}`, {
            timeout: TIMEOUT,
            method: 'DELETE',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiDataEndpointCount = async() => {
    if( !checkPermission('getApiDataEndpointCount', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout('/api/data-endpoint-count', {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}